import { FC, useState } from 'react';
import { ProductDeleteAndWishlistTypeProps } from './TypeProps';
import { useAppSelector } from '@redux/hooks';
import { useWishlist } from '@hooks/useWishlist';
import { IconRedHeart, IconHeart, IconTrashCan } from './icons';
import ClassNames from 'classnames';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

import styles from './ProductDeleteAndWishlist.module.scss';

export const ProductDeleteAndWishlist: FC<ProductDeleteAndWishlistTypeProps> = ({ productId, part, className, handlerDeleteBasket }) => {
  const [isRemoved, setIsRemoved] = useState(false);
  const regionId = useAppSelector(state => state.header.data.region.REGION);
  const { isFlag, handlerAdd, handlerDelete } = useWishlist(productId, part, +regionId);

  const onAddWishlist = () => {
    ServiceEcommerce2.addToWishlist([
      {
        part,
        id: productId,
      },
    ]);

    handlerAdd();
  };

  const onRemoveCart = () => {
    if (!isRemoved) {
      ServiceEcommerce2.removeFromCart([
        {
          part,
          id: productId,
        },
      ]);

      handlerDeleteBasket();
      setIsRemoved(true);
    }
  };

  return (
    <div className={ClassNames(styles.Wrapper, className)}>
      <div onClick={isFlag ? handlerDelete : onAddWishlist} className={styles.Container} data-testid="btn-add-product">
        {isFlag ? <IconRedHeart className={styles.isWishlist} width={16} height={16} /> : <IconHeart width={16} height={16} />}
        {isFlag ? <div className={styles.Label}>Убрать</div> : <div className={styles.Label}>Отложить</div>}
      </div>
      <div onClick={onRemoveCart} className={styles.Container} data-testid="btn-remove">
        <IconTrashCan width={16} height={16} />
        <div className={styles.Label}>Удалить</div>
      </div>
    </div>
  );
};
